var map = {
	"./en/1/nav4.png": 13307,
	"./fi/1/nav4.png": 72221,
	"./in/1/nav4.png": 18335,
	"./th/1/nav4.png": 86448,
	"./tw/1/nav4.png": 86473,
	"./zh/1/nav4.png": 81970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5711;